import React from "react"

export default ({ dir = "rtl", icon, placeholder, onChange, value, onKeyDown, onClick, className, disabled, type, inputStyle, lbl }) => {
  return (
    <label className={"radius-4 " + className} {...(disabled ? { style: { opacity: .45 } } : {})}>
      <div className="flexed align-c h-100">
        <div className="px-8 h-100 inline-flexed align-c text-shadow">
          <span className="font-12">{placeholder}</span></div>
        <div className="flex-1 h-100">
          {lbl && !value && <span className="absolute" style={{
            opacity: .3,
            right: '50%',
            top: '50%',
            transform: 'translate(50%, -50%)'
          }}>{lbl}</span>}
          <input dir={dir} disabled={disabled} type={type || "search"} onChange={e => onChange && onChange(e)} value={value}
            style={{ ...inputStyle }}
            onKeyDown={e => onKeyDown && onKeyDown(e)}
            className="bd-none bg-none dropdown py-8 px-8 font-14 iran-sans-medium iran-sans w-100 text-center h-100 text-shadow" />
        </div>
        {icon && <button className="bd-none bg-none icon-button mx-16 p-0" onClick={() => onClick && onClick()}>
          <img className="icon-sm valign-mid button" src={icon} alt="" />
        </button>}
      </div>

    </label>
  )
}
